export default __webpack_public_path__ + "static/media/SectionCard_Events.963ac17b.jpg";